import { ExperimentInfoDTO } from 'business/models/Models';
export class ExperimentInfo extends ExperimentInfoDTO {
  private isDirty = false;

  setExperimentInfoDetails(
    id: number,
    name: string,
    incubTemp: IncubationTemp,
    setupTemp: SetupTemperature,
    user: User,
    container: Container,
    plateRowCount: number,
    plateColCount: number,
    seeding: boolean,
    reducingAgent: number,
    notes: string,
    noteBookPageNum: string,
    dispensingRobotId: number,
  ) {
    this.id = id;
    this.name = name;
    this.incubTempId = incubTemp.id;
    this.incubTemperature = incubTemp.temperature;
    this.setupTempId = setupTemp.id;
    this.setupTemperature = setupTemp.temperature;
    this.containerId = container.id;
    this.plateType = container.type;
    this.plateRowCount = plateRowCount;
    this.plateColCount = plateColCount;
    this.userId = user.id;
    this.userName = user.name;
    this.reducingAgent = reducingAgent;
    this.seeding = seeding;
    this.notes = notes;
    this.noteBookPageNum = noteBookPageNum;
    this.dispensingRobotId = dispensingRobotId;
  }

  set IsDirty(isDirty: boolean) {
    this.isDirty = isDirty;
  }
  get IsDirty() {
    return this.isDirty;
  }
}

const experimentInfo = new ExperimentInfo();

class IncubationTemp {
  id = 0;
  temperature = '';
}

class SetupTemperature {
  id = 0;
  temperature = '';
}

class User {
  id = 0;
  name = '';
}

class Container {
  id = 0;
  type = '';
}

export default function getExperimentInfoDetails() {
  return experimentInfo;
}

export function newExperimentInfoDetails() {
  return new ExperimentInfo();
}
